/* eslint-disable prefer-destructuring */
import * as CommonNavStepStyles from "../../../../../../../../common-deprecated/styles/v2/lexus/components/NavigationStep";

export const Step = CommonNavStepStyles.Step;

export const StepInner = CommonNavStepStyles.StepInner;

export const StepWithoutLink = CommonNavStepStyles.StepWithoutLink;

export const Icon = CommonNavStepStyles.Icon;

export const Wrapper = CommonNavStepStyles.Wrapper;
